import { isRecordPage } from './isRecordPage';
import { luscinia } from '../luscinia';
import { reloadRecordModal } from '../initializer';

luscinia.handleRecordSave = function (sender: HTMLElement) {
    if (!sender) {
        throw new Error("sender is required for handleRecordSave");
    }

    var isSaveAndContinue = sender.classList.contains("crud-saveandcontinue-btn");
    if (isRecordPage()) {
        if (isSaveAndContinue) {
            luscinia.editModalFormSaveClick(sender, undefined, false, "continue");
        } else {
            luscinia.editModalFormSaveClick(sender, undefined, false, "back");
        }   
    } else {
        if (isSaveAndContinue) {
            luscinia.editModalFormSaveClick(sender, (recordId: string) => {
                reloadRecordModal(sender, recordId);
            }, false);
        } else {
            luscinia.editModalFormSaveClick(sender, undefined, true);
        }
    }
}